
interface NavEntry {
    label: string;
    url: string;
    icon: any;
    mobileOnly?: boolean;
}

import {mapOutline, starOutline, personOutline, informationOutline, documentTextOutline, homeOutline, navigateOutline} from "ionicons/icons";

export const NavigationList: Array<NavEntry> = [
    {
        label: 'Startseite',
        url: '/',
        icon: homeOutline,
        mobileOnly: true
    },
    {
        label: 'Karte',
        url: '/karte',
        icon: mapOutline
    },
    {
        label: 'Konzept',
        url: '/konzept',
        icon: documentTextOutline
    },
    {
        label: 'News',
        url: '/blog',
        icon: starOutline
    },
    {
        label: 'Fahren',
        url: '/fahren',
        icon: navigateOutline
    },
    {
        label: 'Unterstützen',
        url: '/support',
        icon: personOutline
    },
    {
        label: 'Über',
        url: '/about',
        icon: informationOutline
    },
]